import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const CubaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14559'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14559)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.8H20V0H0V2.8Z'
					fill='#0B389F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 8.39998H20V5.59998H0V8.39998Z'
					fill='#0B389F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V11.2H0V14Z'
					fill='#0B389F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0L9.52381 7L0 14V0Z'
					fill='#E12A43'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.3325 7.71585L2.21291 8.51013L2.63776 7.22119L1.52096 6.42314L2.90312 6.42081L3.3325 5.1333L3.76187 6.42081L5.14403 6.42314L4.02724 7.22119L4.45209 8.51013L3.3325 7.71585Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default CubaFlagIcon;
